import authentication from './authentication';
import common from './common';
import routes from './routes';

export default {
    ...authentication,
    ...common,
    ...routes,
}